import { ICopyObraAreaChecklistUseCase } from "../../../presentation/useCases/create/copy_obra_area_checklist_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CopyObraAreaChecklistUseCase
 */

export class CopyObraAreaChecklistUseCase implements ICopyObraAreaChecklistUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async copyObraAreaChecklist(
    idObraAreaChecklist: number,
    area: string,
    copiarChecklist: number,
  ): Promise<void> {
    await this.repository.copyObraAreaChecklist(
      idObraAreaChecklist,
      area,
      copiarChecklist === 1 ? true : false,
    );
  }
}
